module.exports = __webpack_public_path__ + "static/media/photo1.7bf6f745.jpg";